<div [height]="20">    
</div>
<div class="txt" data-testid="Change-payment-text" i18n>

    {{ 'TO_UPDATE_YOUR_CREDIT' | translate }},<br />
    {{ 'OUR_SECURE_PAYMENT_GATEWAY' | translate }}.


</div>
<div [height]="15">
</div>
<div class="cnt-row" style="justify-content: center">
    <div class="line"></div>
</div>
<div [height]="15">
</div>
<div class="cnt-row" style="justify-content: center">    
    
    <simple-btn  [width]="200"
             i18n-text
             [text]="'CONTINUE' | translate"
             [backgroundFillCls]="'o2Background'"
             [hoverFillCls]="'o1Background'"
             [boxShadowCls]="'primary-shadow'"
             (click)="onContinue()"
             [textCls]="'large-btn-text'"
             [height]="40"
             [cornerRadius]="50" 
             [horizontalPadding]="20"
             data-testid="Change-payment-continue-btn">

    </simple-btn>
        
</div>